import { constants } from './constants';
import { ChainId } from '../app/core/config/chain-id';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  theme: 'default',
  application: true,

  rpcUrl: 'https://volta-rpc-vkn5r5zx4ke71f9hcu0c.energyweb.org/',
  chainId: ChainId.Volta,
  cacheServerUrl: 'https://identitycache-dev.energyweb.org/v1',
  natsServerUrl: 'https://identityevents-dev.energyweb.org/',
  ekcUrl: 'https://azure-proxy-server.energyweb.org/api/v1',
  backendUrl: 'https://api2.kistelek.eu:8443/v1',
  authUsername: 'test73',
  authPassword: 's0mepasS^',
  showAzureLoginOption: true,
  natsEnvironmentName: 'ewf-dev',
  rootNamespace: 'iam.ewc',
  mapBoxToken: 'pk.eyJ1IjoiamVycnlib2kiLCJhIjoiY2szeXQ3am11MGN4YjNudXN3ajQzbGp0cyJ9.2lyeSX21QJrdP4fTh96w3A',

  fullNetworkName: 'EnergyWeb Volta Chain',
  networkName: 'Volta',
  currencyName: 'Volta Token',
  currencySymbol: 'VT',
  blockExplorerUrl: 'https://volta-explorer.energyweb.org',
  SENTRY_ENVIRONMENT: 'localhost',
  idleTime: 900, // User was in inactivity for 15 mins(Idle is detected)
  idleTimeout: 900, // 15mins after detected idle
  orgRequestEmail: '',
  ...constants,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
